import React, { useState } from "react";
import { Link } from "react-router-dom";
import classes from "./footer.module.scss";

const FooterLinks = () => {
  const [activeAccordion, setActiveAccordion] = useState(null);
  const { navLinks, contact } = window.footerLinks;

  const toggleAccordion = (key) => {
    setActiveAccordion(activeAccordion === key ? null : key);
  };

  const handleLinks = (list, i) => (
    <li key={i}>
      <Link to={`${process.env.PUBLIC_URL}/` + list.link}>{list.nav}</Link>
    </li>
  );

  const handleAnchors = (list, i) => (
    <li key={i}>
      <a href={list.href} target="_blank" rel="noopener noreferrer">
        {list.nav}
      </a>
    </li>
  );

  const renderGroup = (element, key) => (
    <div
      key={key}
      className={`${classes.footer_links_column} ${activeAccordion === key ? classes.active : ""}`}
    >
      <h3 className={classes.footer_links_title} onClick={() => toggleAccordion(key)}>
        {element.heading}
      </h3>
      <ul className={classes.footer_links_list}>
        {element.links.map((list, j) => {
          if (list.type === "link") return handleLinks(list, j);
          if (list.type === "anchor") return handleAnchors(list, j);
        })}
      </ul>
    </div>
  );

  return (
    <>
      <div className={classes.footer_links}>
        {/* Columns 1–3: COMPANY, SUPPORT, WHY SHOP WITH SUNNY */}
        {navLinks.slice(0, 3).map((element, i) => renderGroup(element, i))}

        {/* Column 4: SHOPPING & ORDERS + RETURNS & VALUE POLICIES stacked */}
        <div className={classes.footer_links_group}>
          {navLinks
            .slice(3, 5)
            .map((element, i) => renderGroup(element, `grp_${i}`))}
        </div>
        {/* Column 5: CONTACT US - Desktop Only */}
        <div
          className={`${classes.footer_links_column} d-none d-md-block`}
        >
          <h3
            className={classes.footer_links_title}
            onClick={() => toggleAccordion("contact")}
          >
            {contact.heading}
          </h3>
          <div className={classes.footer_contact}>
            <p className={classes.footer_contact_address}>{contact.address}</p>
            <a
              href={`mailto:${contact.email}`}
              target="_blank"
              onClick={(e) => e.stopPropagation()}
              className={classes.footer_contact_item}
            >
              <svg
                width="15"
                height="12"
                viewBox="0 0 15 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.5 12C1.0875 12 0.734375 11.8531 0.440625 11.5594C0.146875 11.2656 0 10.9125 0 10.5V1.5C0 1.0875 0.146875 0.734375 0.440625 0.440625C0.734375 0.146875 1.0875 0 1.5 0H13.5C13.9125 0 14.2656 0.146875 14.5594 0.440625C14.8531 0.734375 15 1.0875 15 1.5V10.5C15 10.9125 14.8531 11.2656 14.5594 11.5594C14.2656 11.8531 13.9125 12 13.5 12H1.5ZM7.5 6.75L13.5 3V1.5L7.5 5.25L1.5 1.5V3L7.5 6.75Z"
                  fill="white"
                  fillOpacity="0.7"
                />
              </svg>

              {contact.email}
            </a>
            <a
              href={`tel:${contact.phone.replace(/\s/g, "")}`}
              target="_blank"
              className={classes.footer_contact_item}
            >
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.7125 13.5C11.15 13.5 9.60625 13.1594 8.08125 12.4781C6.55625 11.7969 5.16875 10.8313 3.91875 9.58125C2.66875 8.33125 1.70312 6.94375 1.02188 5.41875C0.340625 3.89375 0 2.35 0 0.7875C0 0.5625 0.075 0.375 0.225 0.225C0.375 0.075 0.5625 0 0.7875 0H3.825C4 0 4.15625 0.059375 4.29375 0.178125C4.43125 0.296875 4.5125 0.4375 4.5375 0.6L5.025 3.225C5.05 3.425 5.04375 3.59375 5.00625 3.73125C4.96875 3.86875 4.9 3.9875 4.8 4.0875L2.98125 5.925C3.23125 6.3875 3.52812 6.83437 3.87187 7.26562C4.21562 7.69688 4.59375 8.1125 5.00625 8.5125C5.39375 8.9 5.8 9.25938 6.225 9.59063C6.65 9.92188 7.1 10.225 7.575 10.5L9.3375 8.7375C9.45 8.625 9.59688 8.54062 9.77813 8.48438C9.95938 8.42813 10.1375 8.4125 10.3125 8.4375L12.9 8.9625C13.075 9.0125 13.2188 9.10312 13.3312 9.23438C13.4437 9.36563 13.5 9.5125 13.5 9.675V12.7125C13.5 12.9375 13.425 13.125 13.275 13.275C13.125 13.425 12.9375 13.5 12.7125 13.5Z"
                  fill="white"
                  fillOpacity="0.7"
                />
              </svg>

              {contact.phone}
            </a>
            <a
              href={`https://wa.me/${contact.whatsapp.replace(/[^0-9]/g, "")}`}
              target="_blank"
              rel="noopener noreferrer"
              className={classes.footer_contact_item}
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.5277 1.97148C10.9061 1.34386 10.1658 0.846293 9.34984 0.507817C8.53392 0.169341 7.65876 -0.00327229 6.77543 4.69763e-05C3.07411 4.69763e-05 0.0576343 3.01568 0.0542441 6.71784C0.0542441 7.90358 0.364452 9.05711 0.950119 10.0784L0 13.5611L3.56316 12.6271C4.54844 13.1646 5.65304 13.4459 6.77543 13.445H6.77882C10.481 13.445 13.4966 10.4293 13.5 6.72377C13.5008 5.84066 13.3268 4.96612 12.9882 4.15052C12.6495 3.33491 12.1537 2.59435 11.5277 1.97148ZM6.77543 12.3075C5.7746 12.3067 4.79232 12.0375 3.931 11.5278L3.72759 11.4057L1.61376 11.96L2.17824 9.8979L2.04602 9.68516C1.48646 8.79549 1.19053 7.76545 1.19252 6.71445C1.19252 3.64118 3.69877 1.13409 6.77882 1.13409C7.51259 1.13277 8.23936 1.27671 8.91724 1.55761C9.59511 1.8385 10.2107 2.2508 10.7285 2.77073C11.2479 3.28872 11.6598 3.90439 11.9402 4.58225C12.2207 5.26012 12.3642 5.98679 12.3626 6.72038C12.3592 9.80467 9.85293 12.3075 6.77543 12.3075ZM9.83937 8.12564C9.6724 8.04173 8.84772 7.63575 8.69261 7.57812C8.53836 7.52302 8.42563 7.49421 8.31545 7.66202C8.20272 7.82899 7.88065 8.20955 7.78403 8.31889C7.6874 8.43161 7.58739 8.44433 7.41957 8.36126C7.2526 8.27651 6.71101 8.10021 6.07025 7.52641C5.57019 7.08144 5.2354 6.53053 5.13539 6.36356C5.03877 6.19574 5.12607 6.1059 5.20997 6.02199C5.28371 5.9474 5.37695 5.82535 5.46085 5.72873C5.54561 5.63211 5.57358 5.56091 5.62867 5.44903C5.68376 5.33546 5.65749 5.23884 5.61596 5.15493C5.57358 5.07102 5.23879 4.24295 5.09725 3.90901C4.96164 3.57931 4.82349 3.62508 4.72008 3.62084C4.62346 3.61491 4.51074 3.61491 4.39801 3.61491C4.31289 3.61707 4.22914 3.63678 4.15199 3.67281C4.07484 3.70883 4.00596 3.76039 3.94965 3.82425C3.79539 3.99207 3.36398 4.39806 3.36398 5.22613C3.36398 6.0542 3.96575 6.85006 4.05051 6.96278C4.13357 7.07551 5.23201 8.76979 6.91782 9.4987C7.31617 9.67245 7.62977 9.775 7.87472 9.85298C8.27731 9.98181 8.64091 9.96231 8.93078 9.92078C9.25285 9.87162 9.92328 9.51395 10.0648 9.12153C10.2038 8.72826 10.2038 8.39262 10.1614 8.32228C10.1199 8.25108 10.0072 8.20955 9.83937 8.12564Z"
                  fill="#fff"
                  fillOpacity="0.7"
                />
              </svg>

              {contact.whatsapp}
            </a>
          </div>
        </div>
      </div>
      {/* Column 5: CONTACT US */}
      <div
        className={`${classes.footer_links_column}  ${classes.contact_column} d-md-none`}
      >
        <h3
          className={classes.footer_links_title}
          onClick={() => toggleAccordion("contact")}
        >
          {contact.heading}
        </h3>
        <div className={classes.footer_contact}>
          <p className={classes.footer_contact_address}>{contact.address}</p>
          <a
            href={`mailto:${contact.email}`}
            onClick={(e) => e.stopPropagation()}
            className={classes.footer_contact_item}
          >
            <svg
              width="15"
              height="12"
              viewBox="0 0 15 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.5 12C1.0875 12 0.734375 11.8531 0.440625 11.5594C0.146875 11.2656 0 10.9125 0 10.5V1.5C0 1.0875 0.146875 0.734375 0.440625 0.440625C0.734375 0.146875 1.0875 0 1.5 0H13.5C13.9125 0 14.2656 0.146875 14.5594 0.440625C14.8531 0.734375 15 1.0875 15 1.5V10.5C15 10.9125 14.8531 11.2656 14.5594 11.5594C14.2656 11.8531 13.9125 12 13.5 12H1.5ZM7.5 6.75L13.5 3V1.5L7.5 5.25L1.5 1.5V3L7.5 6.75Z"
                fill="white"
                fillOpacity="0.7"
              />
            </svg>

            {contact.email}
          </a>
          <a
            href={`tel:${contact.phone.replace(/\s/g, "")}`}
            className={classes.footer_contact_item}
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.7125 13.5C11.15 13.5 9.60625 13.1594 8.08125 12.4781C6.55625 11.7969 5.16875 10.8313 3.91875 9.58125C2.66875 8.33125 1.70312 6.94375 1.02188 5.41875C0.340625 3.89375 0 2.35 0 0.7875C0 0.5625 0.075 0.375 0.225 0.225C0.375 0.075 0.5625 0 0.7875 0H3.825C4 0 4.15625 0.059375 4.29375 0.178125C4.43125 0.296875 4.5125 0.4375 4.5375 0.6L5.025 3.225C5.05 3.425 5.04375 3.59375 5.00625 3.73125C4.96875 3.86875 4.9 3.9875 4.8 4.0875L2.98125 5.925C3.23125 6.3875 3.52812 6.83437 3.87187 7.26562C4.21562 7.69688 4.59375 8.1125 5.00625 8.5125C5.39375 8.9 5.8 9.25938 6.225 9.59063C6.65 9.92188 7.1 10.225 7.575 10.5L9.3375 8.7375C9.45 8.625 9.59688 8.54062 9.77813 8.48438C9.95938 8.42813 10.1375 8.4125 10.3125 8.4375L12.9 8.9625C13.075 9.0125 13.2188 9.10312 13.3312 9.23438C13.4437 9.36563 13.5 9.5125 13.5 9.675V12.7125C13.5 12.9375 13.425 13.125 13.275 13.275C13.125 13.425 12.9375 13.5 12.7125 13.5Z"
                fill="white"
                fillOpacity="0.7"
              />
            </svg>

            {contact.phone}
          </a>
          <a
            href={`https://wa.me/${contact.whatsapp.replace(/[^0-9]/g, "")}`}
            target="_blank"
            rel="noopener noreferrer"
            className={classes.footer_contact_item}
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.5277 1.97148C10.9061 1.34386 10.1658 0.846293 9.34984 0.507817C8.53392 0.169341 7.65876 -0.00327229 6.77543 4.69763e-05C3.07411 4.69763e-05 0.0576343 3.01568 0.0542441 6.71784C0.0542441 7.90358 0.364452 9.05711 0.950119 10.0784L0 13.5611L3.56316 12.6271C4.54844 13.1646 5.65304 13.4459 6.77543 13.445H6.77882C10.481 13.445 13.4966 10.4293 13.5 6.72377C13.5008 5.84066 13.3268 4.96612 12.9882 4.15052C12.6495 3.33491 12.1537 2.59435 11.5277 1.97148ZM6.77543 12.3075C5.7746 12.3067 4.79232 12.0375 3.931 11.5278L3.72759 11.4057L1.61376 11.96L2.17824 9.8979L2.04602 9.68516C1.48646 8.79549 1.19053 7.76545 1.19252 6.71445C1.19252 3.64118 3.69877 1.13409 6.77882 1.13409C7.51259 1.13277 8.23936 1.27671 8.91724 1.55761C9.59511 1.8385 10.2107 2.2508 10.7285 2.77073C11.2479 3.28872 11.6598 3.90439 11.9402 4.58225C12.2207 5.26012 12.3642 5.98679 12.3626 6.72038C12.3592 9.80467 9.85293 12.3075 6.77543 12.3075ZM9.83937 8.12564C9.6724 8.04173 8.84772 7.63575 8.69261 7.57812C8.53836 7.52302 8.42563 7.49421 8.31545 7.66202C8.20272 7.82899 7.88065 8.20955 7.78403 8.31889C7.6874 8.43161 7.58739 8.44433 7.41957 8.36126C7.2526 8.27651 6.71101 8.10021 6.07025 7.52641C5.57019 7.08144 5.2354 6.53053 5.13539 6.36356C5.03877 6.19574 5.12607 6.1059 5.20997 6.02199C5.28371 5.9474 5.37695 5.82535 5.46085 5.72873C5.54561 5.63211 5.57358 5.56091 5.62867 5.44903C5.68376 5.33546 5.65749 5.23884 5.61596 5.15493C5.57358 5.07102 5.23879 4.24295 5.09725 3.90901C4.96164 3.57931 4.82349 3.62508 4.72008 3.62084C4.62346 3.61491 4.51074 3.61491 4.39801 3.61491C4.31289 3.61707 4.22914 3.63678 4.15199 3.67281C4.07484 3.70883 4.00596 3.76039 3.94965 3.82425C3.79539 3.99207 3.36398 4.39806 3.36398 5.22613C3.36398 6.0542 3.96575 6.85006 4.05051 6.96278C4.13357 7.07551 5.23201 8.76979 6.91782 9.4987C7.31617 9.67245 7.62977 9.775 7.87472 9.85298C8.27731 9.98181 8.64091 9.96231 8.93078 9.92078C9.25285 9.87162 9.92328 9.51395 10.0648 9.12153C10.2038 8.72826 10.2038 8.39262 10.1614 8.32228C10.1199 8.25108 10.0072 8.20955 9.83937 8.12564Z"
                fill="#fff"
                fillOpacity="0.7"
              />
            </svg>

            {contact.whatsapp}
          </a>
        </div>
      </div>
    </>
  );
};

export default FooterLinks;
